import { Create } from 'react-admin';
import styledBody from './StyledBody';

export const CreateBody = styledBody(Create);
